import AlertWrapper from './alert-wrapper'
export default AlertWrapper
